var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path8, _path9, _rect11, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOshbusTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1221,
    height: 157,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.639 69.53l62.898-31.445a3.996 3.996 0 011.313-.394l144.128-17.287c.91-.11 1.83.097 2.606.586l154.233 97.06a3.996 3.996 0 001.668.587l233.475 27.15a4.004 4.004 0 003.145-1.006L748.1 30.845a3.999 3.999 0 012.448-1.026l266.032-15.652c.55-.032 1.1.049 1.61.238l185.47 68.098",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeDasharray: "4 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.412,
    y: 50.747,
    width: 39.305,
    height: 39.305,
    rx: 19.653,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.666,
    y: 57,
    width: 26.728,
    height: 26.728,
    rx: 13.364,
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.287 65.029h.527v-.742a.29.29 0 01.292-.287h9.11a.29.29 0 01.292.287v.742h7.985c.583 0 1.077.386 1.234.912l.053-.075-.043.104 1.597 5.564v2.942c0 .33-.272.598-.607.598h-1.385c-.014-.962-.808-1.74-1.79-1.743-.985-.004-1.788.775-1.802 1.743H15.429v-.02c.004-.977-.797-1.772-1.79-1.776-.992-.004-1.8.785-1.803 1.763v.033h-1.549c-.708 0-1.287-.57-1.287-1.268v-7.51c0-.697.579-1.267 1.287-1.267z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.212 76.57a1.53 1.53 0 01-1.18-1.827 1.554 1.554 0 011.854-1.162 1.53 1.53 0 011.18 1.826 1.554 1.554 0 01-1.854 1.162z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.546 75.816a.747.747 0 01-.752-.741c0-.41.337-.742.752-.742.416 0 .753.332.753.742s-.337.741-.753.741zM13.303 76.57a1.53 1.53 0 01-1.19-1.82 1.554 1.554 0 011.849-1.17 1.53 1.53 0 011.189 1.82 1.554 1.554 0 01-1.848 1.17z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.632 75.816a.747.747 0 01-.752-.741c0-.41.336-.742.752-.742s.753.332.753.742-.337.741-.753.741z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.068 67.17h2.962c.134 0 .243.106.243.239v1.866c0 .132-.108.239-.242.239h-2.963a.241.241 0 01-.243-.24V67.41a.24.24 0 01.243-.24zM25.163 69.513h-2.962a.241.241 0 01-.243-.239V67.41c0-.132.108-.24.243-.24h2.962c.134 0 .243.107.243.24v1.865a.24.24 0 01-.243.24zM26.139 67.409c0-.132.108-.24.242-.24h2.113c.182 0 .35.09.453.23l-.003.008.108.235.41 1.367a.338.338 0 01-.3.504h-2.78a.241.241 0 01-.243-.24V67.41zM13.935 67.17h2.963c.134 0 .243.106.243.239v1.866c0 .132-.109.239-.243.239h-2.963a.241.241 0 01-.243-.24V67.41c0-.133.11-.24.243-.24zM9.797 67.17h2.962c.134 0 .243.106.243.239v1.866c0 .132-.11.239-.243.239H9.797a.241.241 0 01-.243-.24V67.41c0-.133.109-.24.243-.24z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 72.593h-.91a.29.29 0 01-.292-.287v-.377a.29.29 0 01.291-.287h.911v.951z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 212.955,
    y: 7.56,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 216.809,
    y: 11.414,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 374.939,
    y: 108.132,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 378.793,
    y: 111.985,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 608.955,
    y: 132.867,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 612.809,
    y: 136.721,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1181.62,
    y: 64.918,
    width: 39.305,
    height: 39.305,
    rx: 19.653,
    fill: "#fff",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1187.91,
    y: 71.207,
    width: 26.728,
    height: 26.728,
    rx: 13.364,
    fill: "#161616"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.67 84.5h-2.11m0 0c0 1.96-.78 3.839-2.17 5.225a7.367 7.367 0 01-5.22 2.164m7.39-7.389c0-1.96-.78-3.84-2.17-5.226a7.366 7.366 0 00-5.22-2.163m0-2.111v2.111m0 0c-1.96 0-3.84.777-5.23 2.163a7.409 7.409 0 00-2.16 5.225c0 1.96.78 3.84 2.16 5.225a7.409 7.409 0 005.23 2.165m-9.5-7.389h2.11m7.39 9.5v-2.111",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.17 88.722c1.12 0 2.19-.445 2.98-1.236a4.233 4.233 0 001.24-2.986c0-1.12-.45-2.194-1.24-2.985a4.206 4.206 0 00-2.98-1.237 4.229 4.229 0 00-4.23 4.222 4.229 4.229 0 004.23 4.222z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 734.615,
    y: 17.988,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 738.469,
    y: 21.841,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1002.62,
    y: 0.988,
    width: 23.583,
    height: 23.583,
    rx: 11.792,
    fill: "#949494"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1006.47,
    y: 4.841,
    width: 15.414,
    height: 15.414,
    rx: 7.707,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOshbusTimeline);
export default __webpack_public_path__ + "static/media/oshbus-timeline.5f527ccc92fcdd7ae9d67024a925d8e7.svg";
export { ForwardRef as ReactComponent };